import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN,
  REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS,
  REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE,
  REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR,
} from './constants';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportOosAccountAccountType(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      if(args.sortedBy === undefined || args.sortedBy === null) {
        args = {
          ...args,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/oosAccount/exportAccountReport`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOosAccountAccountTypeError() {
  return {
    type: REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR,
  };
}

export function useExportOosAccountAccountType() {
  const dispatch = useDispatch();

  const { exportOosAccountAccountTypePending, exportOosAccountAccountTypeError } = useSelector(
    state => ({
      exportOosAccountAccountTypePending: state.reports.exportOosAccountAccountTypePending,
      exportOosAccountAccountTypeError: state.reports.exportOosAccountAccountTypeError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOosAccountAccountType(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOosAccountAccountTypeError());
  }, [dispatch]);

  return {
    exportOosAccountAccountType: boundAction,
    exportOosAccountAccountTypePending,
    exportOosAccountAccountTypeError,
    dismissExportOosAccountAccountTypeError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOosAccountAccountTypePending: true,
        exportOosAccountAccountTypeError: null,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS:
      // The request is success
      return {
        ...state,
        exportOosAccountAccountTypePending: false,
        exportOosAccountAccountTypeError: null,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOosAccountAccountTypePending: false,
        exportOosAccountAccountTypeError: action.data.error,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOosAccountAccountTypeError: null,
      };

    default:
      return state;
  }
}
